// import { useState, useEffect } from 'react';

// const useIsMobile = (breakpoint = 768) => {
//     const [isMobile, setIsMobile] = useState(false);

//     useEffect(() => {
//         const checkMobile = () => setIsMobile(window.innerWidth <= breakpoint);
//         checkMobile();
//         window.addEventListener('resize', checkMobile);
//         return () => window.removeEventListener('resize', checkMobile);
//     }, [breakpoint]);

//     return isMobile;
// };

// export default useIsMobile;
import { useMediaQuery, useTheme } from '@mui/material';

const useIsMobile = () => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
};

export default useIsMobile;
const useIsSmall = () => {
        const theme = useTheme();
        return useMediaQuery('(max-width:990px)', { noSsr: true });
    };
export { useIsSmall };

const useIsMedium = () => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
}
export { useIsMedium };